import HttpClient from '@/common/boot/HttpClient'
import EventBus from '@/common/helpers/EventBus'

const listarFormularios = ({ commit }) => {
  commit('BUSCANDO', true);

  return HttpClient.get(`/formularios/formularios`).then(response => {
    commit('INSERIR_LISTA_FORMULARIOS', response.data.data)
  })
    .finally(() => {
      commit('BUSCANDO', false);
    })
}

const paginarFormularios = ({ commit }, modulo) => {

  commit('BUSCANDO', true);

  return HttpClient.get(`/formularios/paginar-formularios`, {
    params: {
      modulo: modulo
    }
  })
    .then(response => {
      commit('INSERIR_LISTA_FORMULARIOS', response.data.data)
    })
    .finally(() => {
      commit('BUSCANDO', false);
    })
}

const filtrarListarFormularios = async ({ commit }, payload) => {
  commit('BUSCANDO', true);
  return await HttpClient.post('/formularios/filtrar-formularios', payload).then(response => {
    commit('INSERIR_LISTA_FORMULARIOS', response.data.data)
  })
    .finally(() => {
      commit('BUSCANDO', false);
    });
}

const renderizarFormulario = async ({ commit }, payload) => {
  try {
    commit('BUSCANDO', true);
    let formulariosId = payload.formulariosId;
    let instanciaIdent = payload.instanciaIdent;

    let formularios = [];
    let dados;

    if (!isNaN(formulariosId)) {
      formulariosId = [{
        ctrl_formulario_id: formulariosId,
        ctrl_tarefa_id: null
      }];
    }

    for await (let itemId of formulariosId) {
      dados = null;
      dados = await HttpClient.get(`/formularios/formularios/${itemId['ctrl_formulario_id']}`).then(response => {
        return response.data.data;
      })

      const form = {
        id: (Array.isArray(itemId['ctrl_formulario_id'])) ? itemId['ctrl_formulario_id'][0] : itemId['ctrl_formulario_id'],
        dados: fabricaDeRequisicoes(commit, dados),
        ctrl_tarefa_id: itemId['ctrl_tarefa_id']
      }

      formularios.push(form);
    }

    commit('ATUALIZAR_FORMULARIOS_SELECIONADOS', { instanciaIdent: instanciaIdent, formularios: formularios });
    commit('BUSCANDO', false);
  } catch (e) {
    commit('BUSCANDO', false);
  }

}


const inserirOptions = ({ commit }, payload) => {
  commit('INSERIR_ITEM_OPTIONS', payload)
}

const salvarDadosFormulario = ({ commit }, payload, endpoint) => {
  commit('BUSCANDO', true);

  HttpClient.post(endpoint, payload).then(response => {
    return response
  }).finally(() => {
    commit('BUSCANDO', false);
  })
}

const salvarFormulario = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.post('/formularios/formularios', payload).then(response => {
    let moduloName = ''
    if (payload.moduloName) {
      moduloName = payload.moduloName
    }

    let retorno = {
      ...response.data.data,
      ...{
        acl_modulos: {
          modulo: moduloName
        }
      }
    }

    commit('INSERIR_FORMULARIO', retorno)
    return response
  })
    .finally(() => {
      commit('BUSCANDO', false);
    });
}

const atualizarFormulario = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.put(`/formularios/formularios/${payload.id}`, payload).then(response => {
    let moduloName = ''
    if (payload.acl_modulos.id) {
      if (payload.acl_modulo_id != payload.acl_modulos.id) {
        moduloName = payload.moduloName
      } else {
        moduloName = payload.acl_modulos.modulo
      }
    } else {
      if (payload.moduloName) {
        moduloName = payload.moduloName
      } else if (payload.acl_modulos.modulo) {
        moduloName = payload.acl_modulos.modulo
      }
    }

    let retorno = {
      ...response.data.data,
      ...{
        acl_modulos: {
          modulo: moduloName
        }
      }
    }
    commit('ATUALIZAR_FORMULARIO', retorno);
    return response;
  })
    .finally(() => {
      commit('BUSCANDO', false);
    })
}

const excluirFormularios = async ({ commit, dispatch }, payload) => {
  commit('BUSCANDO', true);

  let qtdRows = payload.length;
  for (let i = 0; i < qtdRows; ++i) {
    await excluir(payload[i]);
  }

  commit('BUSCANDO', false);

  dispatch('paginarFormularios');
}

const excluir = async (linha) => {
  const resp = await HttpClient.delete(`/formularios/formularios/${linha.id}`).then(response => { return response; });
  return resp;
}

function fabricaDeRequisicoes(commit, formulario, gatilho = 'load') {
  if (!formulario.corpo) {
    return formulario
  }

  formulario.corpo.forEach(async item => {
    if (item.requisicao) {

      if (item.requisicao.gatilho !== gatilho) {
        return formulario
      }

      const itemOptions = [{
        label: 'Selecione',
        value: ''
      }]

      let response = {}

      if (gatilho == 'load') {
        response = await HttpClient({ method: item.requisicao.metodo, url: item.requisicao.endpoint });
      } else {
        // habilitar requisições com parametros via url
        response = await HttpClient({ method: item.requisicao.metodo, url: item.requisicao.endpoint });
      }

      if (response.status == 200) {
        response.data.data.forEach(respItem => {
          const objOption = {
            label: respItem[item.requisicao.optionLabel],
            value: respItem[item.requisicao.optionValue]
          }
          itemOptions.push(objOption)
        })
        EventBus.$emit('rederizaFormularioNovamente')
        item.options = itemOptions
      }
    }
  })
  return formulario
}

export {
  renderizarFormulario,
  inserirOptions,
  listarFormularios,
  paginarFormularios,
  salvarDadosFormulario,
  salvarFormulario,
  atualizarFormulario,
  excluirFormularios,
  filtrarListarFormularios
}
